// --- Services ----
import LoggerService,{formatTrace} from '../services/LoggerService';

import {setAccessToken,setRefreshToken,setRole,setFunction,KEYS} from '../helpers/localStorageHelper';
import APP_CONFIG from 'config';


/**
 * Custom hook permettant de regrouper les fonctions de manipulation du localStorage,
 * avec check de l'activation du localStorage et du debug
 *
 * Utilisation dans les composants :
 * const {
 *   setAccessTokenInLocalStorage,
 *   setRefreshTokenInLocalStorage,
 * } = useLocalStorage(dispatch);
 *
 * @returns
 */
const useLocalStorage = (dispatch:any) => {

  const logger = LoggerService.getInstance();

  /**
   * Récupère l'access token en local storage
   * @returns
   */
  const getAccessTokenInLocalStorage = ():string|undefined => {
    if (APP_CONFIG.LOCALSTORAGE_ACTIVE) {
      logger.trace(...formatTrace(APP_CONFIG.LOCALSTORAGE_PREFIX));
      const value = window.localStorage.getItem(APP_CONFIG.LOCALSTORAGE_PREFIX + KEYS.KEY_ACCESS_TOKEN);
      if (value === undefined || value === null || value === 'undefined' || value === 'null') {
        return undefined;
      }
      return value;
    }
    logger.trace(...formatTrace('Local storage disabled in .env, cannot get access token from local storage'));
    return undefined;
  };

  /**
   * Ecrit l'access token en local storage
   * @param token
   */
  const setAccessTokenInLocalStorage = async (token?:string) => {
    if (APP_CONFIG.LOCALSTORAGE_ACTIVE) {
      setAccessToken(APP_CONFIG.LOCALSTORAGE_PREFIX,token);
      logger.trace('Stored access token in localStorage.');
      return;
    }
    logger.trace(...formatTrace('Local storage disabled in .env, cannot set access token in local storage'));
  };

  /**
   * Récupère le refresh token en local storage
   * @returns
   */
  const getRefreshTokenInLocalStorage = ():string|undefined => {
    if (APP_CONFIG.LOCALSTORAGE_ACTIVE) {
      const value = window.localStorage.getItem(APP_CONFIG.LOCALSTORAGE_PREFIX + KEYS.KEY_REFRESH_TOKEN);
      if (value === undefined || value === null || value === 'undefined' || value === 'null') {
        return undefined;
      }
      return value;
    }
    logger.trace(...formatTrace('Local storage disabled in .env, cannot get refresh token from local storage'));
    return undefined;
  };

  /**
   * Ecrit le refresh token en local storage
   * @param token
   */
  const setRefreshTokenInLocalStorage = (token?:string) => {
    if (APP_CONFIG.LOCALSTORAGE_ACTIVE) {
      setRefreshToken(APP_CONFIG.LOCALSTORAGE_PREFIX,token);
      logger.trace('Stored refresh token in localStorage.');
      return;
    }
    logger.trace(...formatTrace('Local storage disabled in .env, cannot set refresh token in local storage'));
  };

  /**
   * Récupère le role en local storage
   * @returns
   */
  const getRoleInLocalStorage = ():string|undefined => {
    if (APP_CONFIG.LOCALSTORAGE_ACTIVE) {
      const value = window.localStorage.getItem(APP_CONFIG.LOCALSTORAGE_PREFIX + KEYS.KEY_ROLE);
      if (value === undefined || value === null || value === 'undefined' || value === 'null') {
        return undefined;
      }
      return value;
    }
    logger.trace(...formatTrace('Local storage disabled in .env, cannot get role from local storage'));
    return undefined;
  };

  /**
   * Ecrit le role en local storage
   * @param token
   */
  const setRoleInLocalStorage = (role?:string) => {
    if (APP_CONFIG.LOCALSTORAGE_ACTIVE) {
      setRole(APP_CONFIG.LOCALSTORAGE_PREFIX,role);
      logger.trace('Stored role in localStorage.');
      return;
    }
    logger.trace(...formatTrace('Local storage disabled in .env, cannot set role in local storage'));
  };

  /**
   * Récupère la fonction en local storage
   * @returns
   */
  const getFunctionInLocalStorage = ():string|undefined => {
    if (APP_CONFIG.LOCALSTORAGE_ACTIVE) {
      const value = window.localStorage.getItem(APP_CONFIG.LOCALSTORAGE_PREFIX + KEYS.KEY_FUNCTION);
      if (value === undefined || value === null || value === 'undefined' || value === 'null') {
        return undefined;
      }
      return value;
    }
    logger.trace(...formatTrace('Local storage disabled in .env, cannot get function from local storage'));
    return undefined;
  };

  /**
   * Ecrit la fonction en local storage
   * @param token
   */
  const setFunctionInLocalStorage = (fonction?:string) => {
    if (APP_CONFIG.LOCALSTORAGE_ACTIVE) {
      setFunction(APP_CONFIG.LOCALSTORAGE_PREFIX,fonction);
      logger.trace('Stored function in localStorage.');
      return;
    }
    logger.trace(...formatTrace('Local storage disabled in .env, cannot set function in local storage'));
  };


  return {
    getAccessTokenInLocalStorage,
    setAccessTokenInLocalStorage,
    getRefreshTokenInLocalStorage,
    setRefreshTokenInLocalStorage,
    getRoleInLocalStorage,
    setRoleInLocalStorage,
    getFunctionInLocalStorage,
    setFunctionInLocalStorage,
  };
};

export default useLocalStorage;
